// Exports the "bbcode" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/bbcode')
//   ES2015:
//     import 'tinymce/plugins/bbcode'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/bbcode/index.js
// module id = 6oK/
// module chunks = 1